/* MAROCK — Releasit COD form tweaks + ROCK20 copy-code promo (Oct 2026).
   The COD form is used on the cart page only: on product pages it is hidden, so the
   normal theme product form (quantity - 1 +, Ajouter au panier) is back. In the cart
   form, no +/- ("Quantité : N") and the e-mail note sits under the e-mail field. Idempotent, re-applied
   on DOM changes because Releasit re-renders. Never touches the order itself.
   On desktop the cart form is wide (fields left, summary right). */
(function () {
  'use strict';
  function root() { return document.querySelector('.mk-rsi') || document.getElementById('_rsi-form-container-embedded'); }
  /* Quantity: most orders are 1 per design and size, so no +/- buttons, just
     "Quantité : N" (N = the real cart quantity). Only classes are added; nothing
     is inserted into Releasit's React tree. Styles injected below. */
  var QTY_TXT = /^[+\-−–]$/;
  function qtyPlain(r) {
    r.querySelectorAll('button, [role="button"]').forEach(function (b) {
      if (b.closest('.rsi-discounts-wrapper, .rsi-submit_button')) return;
      var txt = (b.textContent || '').trim();
      var lab = (b.getAttribute('aria-label') || '') + ' ' + (b.getAttribute('class') || '');
      if (!(QTY_TXT.test(txt) || (!txt && /increase|decrease|increment|decrement|plus|minus|quantit/i.test(lab)))) return;
      if (!b.classList.contains('mk-qty-btn')) b.classList.add('mk-qty-btn');
      var p = b.parentElement;
      if (p && !p.classList.contains('mk-qty')) p.classList.add('mk-qty');
    });
  }

  /* E-mail note: small light line right under the e-mail field, instead of the
     text block Releasit shows at the bottom of the form. */
  var EMAIL_NOTE = 'Indiquez votre e-mail pour recevoir la confirmation de votre commande.';
  function emailNote(r) {
    r.querySelectorAll('.rsi-custom-text').forEach(function (el) {
      if (/Indiquez votre e-mail/i.test(el.textContent) && !el.classList.contains('mk-hide')) el.classList.add('mk-hide');
    });
    var inp = r.querySelector('input#email, input[name="email"], input[type="email"]');
    if (!inp) return;
    var box = inp.closest('.rsi-text-input-wrapper') || inp.closest('.rsi-text-input-row');
    if (!box || !box.parentNode) return;
    var nx = box.nextElementSibling;
    if (nx && nx.classList.contains('mk-email-note')) return;
    var n = document.createElement('div');
    n.className = 'mk-email-note';
    n.textContent = EMAIL_NOTE;
    box.after(n);
  }

  /* Cart page: Releasit renders its form inside its own React root (a div at the bottom
     of <body>). marock-cod.js used to move the form itself into the cart summary, which
     cut it off from React, so its buttons (Appliquer, Commander…) stopped working. Here
     the React root moves instead, with the form inside it, so the events keep working. */
  function reactHostParent(el) {
    var k = Object.keys(el).filter(function (x) { return x.indexOf('__reactFiber') === 0; })[0];
    if (!k) return null;
    var f = el[k].return;
    while (f && f.tag !== 5 && f.tag !== 3) f = f.return;
    if (!f) return null;
    return f.tag === 3 ? f.stateNode.containerInfo : f.stateNode;
  }
  function fixMount(r) {
    var page = document.querySelector('.cart-page');
    var summary = page && page.querySelector('.cart-summary__inner');
    if (!summary) return;
    var par = reactHostParent(r);
    if (!par || par === document.body || par.contains(summary)) return;
    if (!summary.contains(par)) {
      if (summary.contains(r)) r.before(par);
      else { var ctas = summary.querySelector('.cart__ctas'); if (ctas) ctas.after(par); else summary.appendChild(par); }
    }
    if (r.parentElement !== par) par.appendChild(r);
  }

  /* Cart page: "Continuer mes achats" link right under the COD form (outside
     Releasit's React tree). Goes back to the shop page the customer came from. */
  function continueLink() {
    var page = document.querySelector('.cart-page');
    var summary = page && page.querySelector('.cart-summary__inner');
    var form = summary && summary.querySelector('.mk-rsi');
    if (!form) return;
    var box = form.parentElement === summary ? form : form.parentElement;
    var nx = box.nextElementSibling;
    if (nx && nx.classList.contains('mk-continue')) return;
    var old = summary.querySelector('.mk-continue');
    if (old) old.remove();
    var href = '/collections/all';
    try { var ref = new URL(document.referrer); if (ref.origin === location.origin && !/^\/cart/.test(ref.pathname)) href = ref.pathname; } catch (e) {}
    var a = document.createElement('a');
    a.className = 'mk-continue';
    a.href = href;
    a.textContent = '← Continuer mes achats';
    box.after(a);
  }

  /* Releasit's floating "Buy with Cash on Delivery" bar (sticky at the bottom on phones)
     is hidden everywhere: ordering happens in the cart form only. */
  function hideFloating() {
    var cands = document.querySelectorAll('button, a, [role="button"]');
    for (var i = 0; i < cands.length; i++) {
      var b = cands[i];
      if (b.closest('.mk-rsi, .cart-summary__inner, #mk-toast, sticky-add-to-cart')) continue;
      if (!/cash on delivery|buy with cash|acheter.*livraison/i.test(b.textContent || '')) continue;
      var e = b, fixedEl = null;
      // nearest fixed wrapper only (never a sticky theme column further up)
      while (e && e !== document.body) { if (getComputedStyle(e).position === 'fixed') { fixedEl = e; break; } e = e.parentElement; }
      var tgt = fixedEl || b;
      if (tgt.querySelector('form[action*="/cart/add"], .mk-rsi') || tgt.getBoundingClientRect().height > 160) continue; // safety
      if (!tgt.classList.contains('mk-hide-float')) tgt.classList.add('mk-hide-float');
    }
  }

  /* injected once: COD form hidden on product pages; cart form shows "Quantité : N" */
  (function () {
    if (document.getElementById('mk-qty-css')) return;
    var st = document.createElement('style');
    st.id = 'mk-qty-css';
    st.textContent = 'html body .mk-rsi .mk-qty button.mk-qty-btn.mk-qty-btn,html body .mk-rsi .mk-qty-btn.mk-qty-btn{display:none!important}.mk-rsi .mk-qty{border:0!important;background:none!important;box-shadow:none!important;width:auto!important;min-width:0!important;gap:4px!important;align-items:center!important}.mk-rsi .mk-qty::before{content:"Quantit\\00E9 :";font-size:13px;font-weight:600;color:#121212;white-space:nowrap}.mk-rsi .mk-qty > *:not(.mk-qty-btn){border:0!important;background:none!important;box-shadow:none!important;padding:0!important;min-width:0!important;width:auto!important;font-weight:700!important}.mk-rsi .mk-qty input{width:2.2ch!important;text-align:left!important;pointer-events:none}html:has(main[data-template^="product"]) [id^="_rsi-form-container"],html:has(main[data-template^="product"]) .mk-rsi,html:has(main[data-template^="product"]) [class*="rsi-form-wrapper"]{display:none!important}.mk-rsi .mk-hide{display:none!important}.mk-rsi .mk-email-note{font-size:12px!important;font-weight:400!important;line-height:1.35;color:#6b6664;margin:4px 2px 0}.mk-promo{background:#e6efe8;border:1.5px dashed #35673F;border-radius:10px;padding:10px 12px;margin:12px 0;display:grid;gap:8px;font-family:inherit;text-align:left}.mk-promo-txt{font-size:14px;line-height:1.35;color:#1f3b25}.mk-promo .mk-code{display:inline-block;background:#0b0b0b;color:#fff;border-radius:4px;padding:1px 7px;font-weight:700;letter-spacing:.06em}.mk-promo .mk-copy{justify-self:start;background:#35673F;color:#fff;border:0;border-radius:6px;padding:8px 14px;font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-weight:700;font-size:15px;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}.mk-promo.mk-copied .mk-copy{background:#0b0b0b}.mk-promo-hint{font-size:12px;color:#6b6664;line-height:1.35}#mk-toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,140%);z-index:2147483000;background:#0b0b0b;color:#fff;border-radius:10px;padding:12px 16px;display:flex;gap:14px;align-items:center;font-size:15px;box-shadow:0 8px 24px rgba(0,0,0,.25);transition:transform .25s;max-width:calc(100vw - 32px)}#mk-toast.mk-show{transform:translate(-50%,0)}#mk-toast a{color:#fff;font-weight:700;text-decoration:underline;white-space:nowrap}html body .mk-rsi .mk-applied:empty{display:none!important}@media (min-width:990px){html.mk-cod-only body .cart-page.mk-cart-cod > .cart-page__summary{max-width:1120px!important}}.mk-continue{display:block;margin:14px auto 4px;width:max-content;max-width:100%;padding:12px 22px;border:2px solid #0b0b0b;border-radius:4px;color:#0b0b0b!important;text-decoration:none!important;font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-weight:700;font-size:17px;letter-spacing:.06em;text-transform:uppercase;text-align:center}.mk-continue:hover{background:#0b0b0b;color:#fff!important}html body .mk-hide-float{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  })();

  /* Product page: after "Ajouter au panier" the customer stays on the page and sees a
     short confirmation with a link to the cart (where the COD form is). */
  function toast() {
    var t = document.getElementById('mk-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'mk-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span>✓ Ajouté au panier</span><a href="/cart">Voir le panier</a>';
      document.body.appendChild(t);
    }
    t.classList.add('mk-show');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('mk-show'); }, 4500);
  }
  document.addEventListener('cart:update', function (e) {
    var m = document.querySelector('main[data-template]');
    if (!m || !/^product/.test(m.dataset.template)) return;
    var d = (e.detail && e.detail.data) || {};
    if (!d.didError) toast();
  });

  /* ROCK20 promo (code, not automatic): message + "Copier le code" button in the cart
     form above the code field (not on product pages). */
  var CODE = 'ROCK20';
  function copyText(txt) {
    try { if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(txt); } catch (e) {}
    return new Promise(function (ok) {
      var ta = document.createElement('textarea');
      ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      ta.remove(); ok();
    });
  }
  function promoBox(where) {
    var el = document.createElement('div');
    el.className = 'mk-promo mk-promo-' + where;
    el.innerHTML = '<div class="mk-promo-txt">🤘 En ce moment : <b>-20 DH</b> avec le code <span class="mk-code">' + CODE + '</span></div>' +
      '<button type="button" class="mk-copy">Copier le code</button>' +
      '<div class="mk-promo-hint">' + (where === 'cart' ? 'Collez-le dans la case « Code de réduction » ci-dessous, puis Appliquer.' : 'Collez-le dans la case « Code de réduction » du panier.') + '</div>';
    el.querySelector('.mk-copy').addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      var btn = this;
      Promise.resolve(copyText(CODE)).then(function () {
        btn.textContent = 'Code copié ✓';
        el.classList.add('mk-copied');
        setTimeout(function () { btn.textContent = 'Copier le code'; el.classList.remove('mk-copied'); }, 3000);
      });
    });
    return el;
  }
  function promoCart(r) {
    var m = document.querySelector('main[data-template]');
    if (m && /^product/.test(m.dataset.template)) return;
    var w = r.querySelector('.rsi-discounts-wrapper');
    if (!w) return;
    var n = w.querySelector('.mk-disc-note');
    if (n && n.textContent !== 'Un seul code par commande.') n.textContent = 'Un seul code par commande.';
    var p = w.previousElementSibling;
    if (p && p.classList.contains('mk-promo')) return;
    w.before(promoBox('cart'));
  }

  var busy = false, t;
  function run() { if (busy) return; busy = true; try { var r = root(); if (r) { try { fixMount(r); } catch (e) {} qtyPlain(r); emailNote(r); promoCart(r); } } catch (e) {} try { continueLink(); } catch (e) {} try { hideFloating(); } catch (e) {} busy = false; }
  function start() {
    run();
    // throttle (not debounce): pages that change the DOM non-stop must not starve run()
    new MutationObserver(function () { if (!t) t = setTimeout(function () { t = null; run(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();